import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [0, 0, 50],
    },
    title: {
      marginBottom: 8,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 12,
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 28,
        textAlign: "left",
      },
    },
    grid: {
      marginBottom: 40,
    },
    placeholder: {
      marginBottom: 20,
    },
  }),
  { name: "StarringYouCards" },
);
